import './index.scss'
import { Link } from 'component_library/1_Atoms'
import PhoneNumberLink from 'common/PhoneNumberLink'
import { providerSearchNumber } from 'constants/common'
import classNames from 'classnames'
import SalesforceSync from './SalesforceSync'
import useSalesforceLead from 'hooks/salesforce/useSalesforceLead'
import useSalesforceCase from 'hooks/salesforce/useSalesforceCase'
import { getCallCenterStatus } from 'app/ProviderSearch/utils'
import { pageRoutes } from 'constants/routing'
import { useEffect, useState } from 'react'

type PrenavProps = {
  callUsBannerNumber?: CallUsNavBarBanner
  containerStyle?: string
}

const Prenav: React.FC<PrenavProps> = ({
  callUsBannerNumber,
  containerStyle,
}) => {
  const { hasLeadId } = useSalesforceLead()
  const { hasCaseId } = useSalesforceCase()
  const isSalesforceSyncEnabled = hasLeadId || hasCaseId

  // The hours are shown in the visitor's time zone, which the server does not
  // know. Work them out in the browser only, so the server and browser HTML
  // match when the page loads.
  const [callCenterStatus, setCallCenterStatus] = useState<ReturnType<
    typeof getCallCenterStatus
  > | null>(null)

  // Refresh every minute, so a page left open still flips at opening and
  // closing time.
  useEffect(() => {
    const refreshCallCenterStatus = () => {
      setCallCenterStatus(getCallCenterStatus())
    }

    refreshCallCenterStatus()
    const statusRefreshInterval = setInterval(refreshCallCenterStatus, 60_000)

    return () => clearInterval(statusRefreshInterval)
  }, [])

  const phoneNumber = callUsBannerNumber
    ? callUsBannerNumber.number
    : providerSearchNumber.phoneNumber

  const formattedPhoneNumber = callUsBannerNumber
    ? callUsBannerNumber.formattedNumber
    : providerSearchNumber.formattedPhoneNumber

  const isCallCenterStatusOpen = !!callCenterStatus?.isCallCenterStatusOpen

  return (
    <div
      className={classNames('NavbarCallusSection', containerStyle, {
        ['NavbarCallusSection--open']: isCallCenterStatusOpen,
      })}
    >
      {isSalesforceSyncEnabled ? (
        <SalesforceSync />
      ) : (
        callCenterStatus && (
          <>
            {isCallCenterStatusOpen ? (
              <>
                <div className="NavbarCallusSection__statusIcon" />
                <span className="NavbarCallusSection__callCenterText">
                  We&apos;re open until {callCenterStatus.nextEvent}.&nbsp;
                  <span className="NavbarCallusSection__bookOnlineText">
                    Book online or c
                  </span>
                  <span className="NavbarCallusSection__mobileOnlyText">C</span>
                  all us at&nbsp;
                  <PhoneNumberLink
                    href={`tel:${phoneNumber}`}
                    className="NavbarCallusSection--callusHover"
                    phoneNumberCTA={formattedPhoneNumber}
                  >
                    {formattedPhoneNumber}
                  </PhoneNumberLink>
                </span>
              </>
            ) : (
              <div>
                <Link
                  href={pageRoutes.PROVIDER_SEARCH}
                  className="NavbarCallusSection__bookNowLink"
                >
                  Book online now&nbsp;
                </Link>{' '}
                Or, call when we open at&nbsp;
                <b>{callCenterStatus.nextEvent}</b>
              </div>
            )}
          </>
        )
      )}
    </div>
  )
}

export default Prenav
